/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  CheckingValidSearch,
  clickTracker,
  getContractTypeVal,
  getCookie,
  getFaqPageType,
  getProjectId,
  getSourceValue,
  handleRedirection,
  helpfulObjData,
  trackerObj,
} from '../lib/common';
import WithCsportalAuth from '../hooks/WithCsportalAuth';
import { useAuth } from '../contexts/auth';
import { onClickEvent } from '../lib/gaAnalytics';
import { handleLoginPopup, handleSetFaqData } from '../reducersAndActions/actions/appStateActions';
import { useLocalStorage, usePopup, useSelectedBusiness, useSessionStorage } from '../hooks';
import { GetFaqs, handleImpressionsTrack } from '../api';
import { useAppState } from '../contexts/appState';
import useAlert from '../hooks/useAlert';
import RaiseTicket from './RaiseTicket';
import styles from '../styles/Accordion.module.scss';
import { Business, CommonPopup, FaqTicketCreate, FaqWrapper, Shimmer } from '../components';

function Faq() {
  const [appState, appDispatch] = useAppState();
  const [authState] = useAuth();
  const { allBusinesses, sidResponse, type } = authState;
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const { setSelectedBusinessState } = useSelectedBusiness();
  const params = useParams();
  const [selectedFaq, setSelectedFaq] = useState('');
  const [searchQuestion, setSearchQuestion] = useState('');
  const [issueComment, setIssueComment] = useState('');
  const [faqData, setFaqData] = useState([]);
  const [faqResponse, setFaqResponse] = useState(
    appState?.faqData && appState?.faqData.length > 0 ? appState?.faqData : [],
  );
  const [setAlert] = useAlert();
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(window.location.search);
  const docid = queryParams.get('docid');
  const [ticketStatusResp, setTicketStatusResp] = useState('');
  const [hLinkResp, setHLinkResp] = useState('');
  const navigate = useNavigate();
  const source = getSourceValue();
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showData, setShowData] = useState(false);
  const [setPopup] = usePopup();
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  const [helpful, setHelpful] = useState(helpfulObjData);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');
  const projectId = getProjectId();
  const contractVal = getContractTypeVal(projectId);

  const manageCampainUrl = `https://wap.justdial.com/manage_campaign.php?docid=${
    selectedBusiness.docid
  }&hide_header=1&wkwebview=1&mybus=1&mobile=${
    (userDetails && userDetails.mobile) || ''
  }&newcs=1&source=${source}&case=selpckg`;

  const jdrrUrl = `https://www.justdial.com/BNR-${
    selectedBusiness && selectedBusiness.shorturl
  }?hide_header=1&support=1&source=${source}`;

  const nonLoginFaqKeysObj = {
    'JD-Pay': 'JdPay_Nonlogin',
    'Edit-my-Business': 'Edit-my-Business',
    Payments: 'Payments_Nonlogin',
    Leads: 'Leads_Nonlogin',
  };

  useEffect(() => {
    const storedFeedbackData = sessionStorage.getItem('faqsFeedback');
    if (storedFeedbackData) {
      setFaqsFeedbackData(JSON.parse(storedFeedbackData));
    }
  }, []);

  useEffect(() => {
    const handleGetFaqs = async () => {
      if ((params?.key && sidResponse) || (!sidResponse && appState?.loginPopup?.nonlogin)) {
        if (appState.faqData && appState.faqData.length === 0) {
          try {
            setLoading(true);
            const paramsData = {
              key: sidResponse ? params?.key || '' : nonLoginFaqKeysObj[params.key],
              docId: selectedBusiness.docid || '',
              parentId: selectedBusiness.parentid || '',
              mobile: (userDetails && userDetails.mobile) || '',
              compName: selectedBusiness.compname ? encodeURIComponent(selectedBusiness.compname) : '',
              area: selectedBusiness.areaname ? encodeURIComponent(selectedBusiness.areaname) : '',
              city: selectedBusiness.data_city ? encodeURIComponent(selectedBusiness.data_city) : '',
              source,
              sid: getCookie('sid') || '',
              shortUrl: selectedBusiness.shorturl || '',
            };
            const res = await GetFaqs(paramsData);
            if (searchQid && searchQid !== '') {
              res.result?.forEach((ele, i) => {
                if (ele?.id?.toString() === searchQid) {
                  res.result?.splice(i, 1);
                  res.result?.unshift(ele);
                }
              });
            }
            if (res.errorCode === 0) {
              setFaqData(res.result || []);
              setFaqResponse(res.result || []);
              handleSetFaqData(appDispatch, {
                faqData: res.result || [],
              });
            }
            setLoading(false);
          } catch (e) {
            console.log(e);
            setLoading(false);
          }
        } else {
          setFaqData(appState?.faqData || []);
          setFaqResponse(appState?.faqData || []);
          setLoading(false);
        }
      }
    };

    handleGetFaqs();
  }, [hLinkResp, sidResponse, appState?.loginPopup?.nonlogin]);

  useEffect(() => {
    if (allBusinesses?.length > 0 && docid) {
      let businessFound = false;
      allBusinesses.forEach((business) => {
        if (business?.docid === docid) {
          businessFound = true;
          setSelectedBusinessState(business);
        }
      });

      if (!businessFound) {
        handleLoginPopup(appDispatch, {
          open: true,
          desc: "It looks like you've logged in with different mobile number, please login with your required registered mobile number.",
          login: false,
        });
      }
    }
  }, [allBusinesses]);

  const handleClick = async (paramUrl) => {
    try {
      let url = '';
      if (params.key === 'ECS') {
        url = paramUrl || '';
      } else {
        url = paramUrl || (params.key === 'Banner-JDRR' ? jdrrUrl : manageCampainUrl);
      }
      handleRedirection(source, url);
    } catch (err) {
      setAlert({
        message: `Something went wrong! ${err}`,
        status: false,
      });
    }
  };

  const handleSubmit = (msg) => {
    setTicketStatusResp(msg);
    setIssueComment('');
  };

  const handleHelpfulClick = async (index, apiKey, faqId) => {
    const value = index === 0 ? 'Helpful' : 'NotHelpful';

    const updatedData = {
      ...faqsFeedbackData,
      [faqId]: value,
    };
    setFaqsFeedbackData(updatedData);
    sessionStorage.setItem('faqsFeedback', JSON.stringify(updatedData));

    onClickEvent(`CSFAQ-helpful`, value === 'Helpful' ? 'Helpful' : 'Not Helpful', `FAQ-${faqId}`);

    await clickTracker(`${apiKey}_${value === 'Helpful' ? 'yes' : 'no'}`, 'faq_feedback');
  };

  const handleSearchFaq = (e) => {
    setSearchQuestion(e.target.value);
    const filteredFaqData =
      faqResponse && faqResponse.filter((each) => each.question.toLowerCase().includes(e.target.value.toLowerCase()));
    setFaqData(filteredFaqData);
  };

  const handleClosePopup = () => {
    document.body.style.overflow = 'unset';
    setPopup({});
  };

  const handleIssueSubmit = () => {};

  const handleTicketCreate = async () => {
    onClickEvent(`CSFAQ Page`, 'Raise CS Ticket', 'Raise CS Ticket');
    if (appState?.loginPopup?.nonlogin && !sidResponse) {
      handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
      return '';
    }
    if (selectedBusiness?.parentid && selectedBusiness?.data_city) {
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `cta_raiseticket`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `issue_${trackerObj?.[params?.key]}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
      if (projectId === 'csportal' && ['paid', 'expiredShort'].includes(contractVal)) {
        const raiseTicketTrackerID = params.key === 'Website-App-Related' ? 'webapp' : trackerObj?.[params?.key];
        navigate(`/csportal/create_ticket?parentId=${selectedBusiness.parentid}&city=${
          selectedBusiness.data_city
        }&key=${params.key}&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}
          &raiseTicketTrackerID=${raiseTicketTrackerID}`);
      } else {
        const raiseTicketTrackerID = params.key === 'Website-App-Related' ? 'webapp' : trackerObj?.[params?.key];
        navigate(
          `/csportal/create_ticket?parentId=${selectedBusiness.parentid}&city=${
            selectedBusiness.data_city
          }&key=${params.key}&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}
          &raiseTicketTrackerID=${raiseTicketTrackerID}`,
        );
      }
    } else if (appState?.loginPopup?.nonlogin) {
      handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
      return '';
    }
    return null;
  };

  const handleFaqClick = async (faqObj, index) => {
    const isClosing = index === activeIndex; // true if we're closing
    // RESET feedback for this FAQ when closing or opening new one
    setFaqsFeedbackData((prev) => {
      const updated = { ...prev };
      delete updated[faqObj.id]; // remove this FAQ's feedback so it resets
      return updated;
    });
    setShowData(true);
    setActiveIndex(isClosing ? -1 : index);
    setTicketStatusResp('');
    setSelectedQuestionId(selectedQuestionId === faqObj?.pop ? null : faqObj?.pop);
    setHelpful(helpfulObjData);

    const { faqType, faqKey, question, ans, videoUrl } = faqObj;
    if (faqType === 'Banner-JDRR' && hLinkResp) {
      handleSetFaqData(appDispatch, {
        faqData: [],
      });
    }
    setHLinkResp('');

    if (selectedQuestionId !== faqObj?.pop) {
      await clickTracker(`faq_${faqKey}`, `${getFaqPageType[params.key]}_faq`);
      onClickEvent(`CSFAQ-${type}-${params.key}`, question, question);
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${faqObj?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `issue_${trackerObj?.[params?.key]}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }

    if (params?.key === 'Leads' && [5, 7].includes(index)) {
      const updatedLeadsAns = ans.replace(
        '<videoURL>',
        `<div style="display: flex;justify-content: center;margin-top:10px;"><iframe title="videoUrl" allowFullScreen src=https://www.youtube.com/embed/${videoUrl}> </iframe></div>`,
      );
      setSelectedFaq(updatedLeadsAns);
    } else {
      const url = params.key === 'Banner-JDRR' ? jdrrUrl : manageCampainUrl;
      const updatedAns = ans && ans.replace('<URL>', url);
      setSelectedFaq(updatedAns);
    }

    setIssueComment('');
  };

  useEffect(() => {
    if (searchQid && searchQid !== '') {
      faqData?.forEach((faq, i) => {
        if (faq?.id?.toString() === searchQid) {
          handleFaqClick(faq, i);
        }
      });
    }
  }, [faqData]);

  useEffect(() => {
    setFaqsFeedbackData({});
  }, []);

  const validSearchValue = CheckingValidSearch(searchQuestion);

  return (
    <>
      <section className="cspage csfaq no-highlighting">
        <div className="csfaqexpand p-20">
          <div className="csinstans font16 fw600 color111 text_center mt-5 ">
            Questions? We&apos;ve got <br />
            instant answers
          </div>
          <div className={`${styles.Accordion__Search} mt-10`}>
            <input
              value={searchQuestion}
              onChange={handleSearchFaq}
              type="search"
              placeholder="Search for keywords..."
              className={`${styles.Accordion__Input} font12 fw500 color111`}
            />
          </div>
          {!validSearchValue && searchQuestion && (
            <span className="colorEC4 font12">Please avoid special characters.</span>
          )}
          <div className="mt-10">
            {loading ? (
              <Shimmer loading={loading} id="faq" />
            ) : (
              <>
                {faqData && faqData?.length > 0 ? (
                  <>
                    {faqData &&
                      faqData.map((each, idx) => (
                        <div key={idx}>
                          <div
                            onClick={() => handleFaqClick(each, idx)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={() => {}}
                            className={`${styles.Accordion__Pannel__Heading} ${
                              activeIndex === idx ? styles.Active : ''
                            }`}
                          >
                            <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                              {each?.question || ''}
                            </div>
                            <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                          </div>
                          {showData && activeIndex === idx && (
                            <>
                              <div
                                className={`${styles.Accordion__Contant__UBL}`}
                                style={{
                                  width: faqsFeedbackData[each.id] === 'NotHelpful' ? undefined : '100%',
                                }}
                              >
                                {faqsFeedbackData[each.id] !== 'NotHelpful' && (
                                  <div className={`${styles.Accordion__TextContant}`}>
                                    {['popup', 'create'].includes(each?.type) ? (
                                      <>
                                        {each.type === 'create' && (
                                          <div
                                            aria-hidden="true"
                                            id="faqPage-ans"
                                            className="color777 font12 p-10"
                                            dangerouslySetInnerHTML={{ __html: each?.ans }}
                                          />
                                        )}

                                        <div className="csexpndwp active">
                                          <div className="csexpndwp_content">
                                            {ticketStatusResp ? (
                                              <div className="color777 font14 ml-10">{ticketStatusResp || ''}</div>
                                            ) : (
                                              <>
                                                {params?.key && params?.key === 'ECS' && each?.pop === 9 && (
                                                  <>
                                                    <input
                                                      id="ecsLabel"
                                                      className="ml-16"
                                                      type="radio"
                                                      defaultChecked
                                                    />
                                                    <label htmlFor="ecsLabel" className="font12 color007 mb-10">
                                                      ECS Related Clarification
                                                    </label>
                                                    <input
                                                      id="username"
                                                      className="ml-16"
                                                      type="radio"
                                                      defaultChecked
                                                    />
                                                  </>
                                                )}
                                                <div className="p-10">
                                                  <FaqTicketCreate
                                                    issue={each?.issue || ''}
                                                    subIssue={each?.subIssue || ''}
                                                    activeIndex={activeIndex}
                                                    vertical={params?.key === 'ECS' ? 'Retention' : 'LISTING'}
                                                    category="CS"
                                                    ticketCreator={
                                                      type === 'user'
                                                        ? 'USER'
                                                        : type === 'business'
                                                          ? 'BUSINESS'
                                                          : 'OTHER'
                                                    }
                                                    setShowData={setShowData}
                                                    hideAlert
                                                    hideCrossIcon
                                                    id="faqPage"
                                                    faqId={each?.pop}
                                                    projectId="csportal"
                                                    trackerKey={each?.faqKey}
                                                    handleContractCheckboxSubmit={handleSubmit}
                                                    faqObj={each}
                                                  />
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    ) : each.type === 'button' ? (
                                      <>
                                        {each.extraText ? (
                                          <div
                                            id="faqPage-ans"
                                            className="color777 font12 p-10"
                                            dangerouslySetInnerHTML={{ __html: each.extraText }}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                        {appState?.loginPopup?.nonlogin && !sidResponse && each?.pop !== 11 ? (
                                          <div
                                            id="faqPage-ans"
                                            className="color777 font12 p-10"
                                            dangerouslySetInnerHTML={{ __html: each.ans }}
                                          />
                                        ) : (
                                          <>
                                            {(params?.key !== 'JD-Pay' ||
                                              (params?.key === 'JD-Pay' && each?.pop !== 5)) && (
                                              <div
                                                tabIndex={0}
                                                role="button"
                                                onKeyDown={() => {}}
                                                style={{ textDecoration: 'underline' }}
                                                onClick={() => handleClick(each.paramUrl || '', each)}
                                                type="button"
                                                className="clr007 font15 fw500 faq-click-here-button ml-10"
                                              >
                                                Click here
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : each.ans.includes('<URL>') ? (
                                      <div
                                        id="faqPage-ans"
                                        className="color777 font12 p-10"
                                        dangerouslySetInnerHTML={{ __html: selectedFaq }}
                                      />
                                    ) : (
                                      <>
                                        <div
                                          id="faqPage-ans"
                                          className="color777 font12 p-10"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              params?.key === 'Leads' && [6, 8].includes(each.pop)
                                                ? selectedFaq
                                                : each.ans,
                                          }}
                                        />
                                        {(params?.key === 'UBL' ||
                                          (each?.faqType === 'LeadBank' &&
                                            each?.issue != null &&
                                            faqsFeedbackData?.[each?.id] !== 'NotHelpful')) && (
                                          <div className={`${styles.Accordion__Helpful} mt-20 mb-10`}>
                                            <div className="font11 fw400 color777 mr-10">Was this Helpful?</div>

                                            {helpful &&
                                              helpful?.map((item) => (
                                                <div
                                                  key={item.id}
                                                  role="button"
                                                  tabIndex={0}
                                                  onClick={() =>
                                                    handleHelpfulClick(item.id, each?.faqKey || each?.apiKey, each?.id)
                                                  }
                                                  onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                      handleHelpfulClick(
                                                        item.id,
                                                        each?.faqKey || each?.apiKey,
                                                        each?.id,
                                                      );
                                                    }
                                                  }}
                                                  className={`${item?.icon} ${
                                                    (item.id === 0 && faqsFeedbackData?.[each?.id] === 'Helpful') ||
                                                    (item.id === 1 && faqsFeedbackData?.[each?.id] === 'NotHelpful')
                                                      ? styles.Active
                                                      : ''
                                                  } csicon mr-10`}
                                                  aria-label={item.id === 0 ? 'Helpful' : 'Not helpful'}
                                                />
                                              ))}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                              {(params?.key === 'UBL' || (each?.faqType === 'LeadBank' && each?.issue != null)) &&
                                faqsFeedbackData?.[each?.id] === 'NotHelpful' && (
                                  <div>
                                    <FaqTicketCreate
                                      issue={each?.issue || ''}
                                      subIssue={each?.subIssue || ''}
                                      activeIndex={activeIndex}
                                      setShowData={setShowData}
                                      vertical="LISTING"
                                      category="CS"
                                      ticketCreator="BUSINESS"
                                      hideAlert
                                      id="leads"
                                      faqId={each?.id}
                                      hideCrossIcon
                                      faqObj={each}
                                    />
                                  </div>
                                )}{' '}
                            </>
                          )}
                        </div>
                      ))}
                    {params?.key !== 'Events' && <RaiseTicket handleTicketCreate={handleTicketCreate} />}
                  </>
                ) : (
                  validSearchValue && <div className="no-data-div">No Data</div>
                )}
              </>
            )}
          </div>
        </div>
      </section>

      {!sidResponse && <Business pageType="faq" />}

      {appState?.popupObj?.popupType === 'postIssue' && (
        <CommonPopup
          comment={issueComment}
          setComment={setIssueComment}
          handleCommentSubmit={handleIssueSubmit}
          handleClosePopup={handleClosePopup}
        />
      )}
    </>
  );
}

export default WithCsportalAuth(FaqWrapper(Faq));
